import { apiClient } from "../../../../api/httpClient";
import { RETRIEVAL_GUARDIAN_BOND } from "../guardianFormConfig";

/**
 * @param {object} ctx
 * @param {string} ctx.bondKind
 * @param {object} ctx.keys
 * @param {object} ctx.cfg
 * @param {React.MutableRefObject<object>} ctx.dataRef
 * @param {function} ctx.updateData
 * @param {function} ctx.updateGuardianAt
 */
export function createPgHandlers({
  bondKind,
  keys,
  cfg,
  dataRef,
  updateData,
  updateGuardianAt,
}) {
  const fetchProfessionalGuardianDetails = async (index, id) => {
    try {
      const response = await apiClient(`/guardian-details/${id}/`, "GET");
      const currentData = dataRef.current;
      const updatedGuardians = Array.isArray(currentData.guardians)
        ? [...currentData.guardians]
        : [];
      const patch = {
        [keys.name]: response.full_name,
        [keys.address]: response.mailing_address,
        [keys.city]: response.city,
        [keys.state]: response.state,
        [keys.zip]: response.zip_code,
        professional_guardian: id,
        is_professional_guardian: "Yes",
        is_new_pg: false,
        showFullForm: false,
      };
      if (cfg.fetchPgIncludesEmail) {
        patch[keys.email] = response.email;
      }
      updatedGuardians[index] = {
        ...updatedGuardians[index],
        ...patch,
      };
      updateData({ ...currentData, guardians: updatedGuardians });
    } catch (error) {
      console.error("Error fetching professional guardian details", error);
    }
  };

  const handleProfessionalGuardianChange = (index, value, guardian, guardians) => {
    if (bondKind === RETRIEVAL_GUARDIAN_BOND.probate) {
      updateGuardianAt(
        index,
        {
          is_professional_guardian: value,
          professional_guardian: null,
          showFullForm: value === "Yes" ? guardian.showFullForm : false,
          is_new_pg: false,
          is_attorney: "No",
          attorney: null,
        },
        guardians
      );
      return;
    }
    const patch = {
      is_professional_guardian: value,
      showFullForm: value === "Yes" ? guardian.showFullForm : false,
      professional_guardian: null,
      is_new_pg: false,
    };
    if (bondKind !== RETRIEVAL_GUARDIAN_BOND.va) {
      patch.attorney = null;
    }
    updateGuardianAt(index, patch, guardians);
  };

  return { fetchProfessionalGuardianDetails, handleProfessionalGuardianChange };
}
